"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _userQuery = require("@/apollo/queries/user-query");
var _work_experienceQuery = require("@/apollo/queries/work_experience-query");
var _importCsvUserUtil = require("@/utils/import-csv-user-util");
var _auth = require("@/utils/auth");
var _timeUtil = require("@/utils/time-util");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      display_information: {
        disp_name: true,
        // 名前を表示する
        disp_birthday: true,
        // 生年月日を表示する
        disp_sex: true,
        // 性別を表示する
        disp_age: true,
        // 年齢を表示する
        disp_address: true,
        // 住所を表示する
        disp_final_education: true,
        // 最終学歴を表示する
        disp_work_history: true,
        // 職歴（直近のもの）を表示する
        disp_qualification: true,
        // 資格を表示する
        disp_transportation_facilities: true,
        // 交通機関を表示する
        disp_desired_work_day: true,
        // 勤務希望日数を表示する
        disp_overtime: true,
        // 残業を表示する
        disp_preferred_date: true,
        // 希望スタート日時を表示する
        disp_pr_comment: true // PRコメント
      },
      form: [{
        id: '',
        // ID
        staff_code: '',
        // スタッフコード
        name: '',
        // 氏名
        name_furigana: '',
        // 氏名（ふりがな）
        birthday: '',
        // 誕生日
        age: '',
        // 年齢
        sex: '',
        // 性別（1=男性、2=女性）
        post_code: '',
        // 郵便番号
        address: '',
        // 住所
        address_furigana: '',
        // 住所（ふりがな）
        phone_number: '',
        // 電話番号
        current_date_year: '',
        // 現在（年）
        current_date_month: '',
        // 現在（月）
        current_date_day: '',
        // 現在（日）
        final_education_year: '',
        // 最終学歴（年）
        final_education_month: '',
        // 最終学歴（月）
        final_education_exp: '',
        // 最終学歴（内容）
        work_exp_list: [],
        work_exp_year1: '',
        // 職歴年（1行目）
        work_exp_month1: '',
        // 職歴月（1行目）
        work_exp1: '',
        // 職歴内容（1行目）
        work_exp_year2: '',
        // 職歴年（2行目）
        work_exp_month2: '',
        // 職歴月（2行目）
        work_exp2: '',
        // 職歴内容（2行目）
        work_exp_year3: '',
        // 職歴年（3行目）
        work_exp_month3: '',
        // 職歴月（3行目）
        work_exp3: '',
        // 職歴内容（3行目）
        work_exp_year4: '',
        // 職歴年（4行目）
        work_exp_month4: '',
        // 職歴月（4行目）
        work_exp4: '',
        // 職歴内容（4行目）
        work_exp_year5: '',
        // 職歴年（5行目）
        work_exp_month5: '',
        // 職歴月（5行目）
        work_exp5: '',
        // 職歴内容（5行目）
        work_exp_year6: '',
        // 職歴年（6行目）
        work_exp_month6: '',
        // 職歴月（6行目）
        work_exp6: '',
        // 職歴内容（6行目）
        work_exp_year7: '',
        // 職歴年（7行目）
        work_exp_month7: '',
        // 職歴月（7行目）
        work_exp7: '',
        // 職歴内容（7行目）
        work_exp_year8: '',
        // 職歴年（8行目）
        work_exp_month8: '',
        // 職歴月（8行目）
        work_exp8: '',
        // 職歴内容（8行目）
        requirements: '',
        // 資格
        commuting_time_hours: '',
        // 通勤時間（時）
        commuting_time_minutes: '',
        // 通勤時間（分）
        transportation: '',
        // 交通機関
        working_days: '',
        // 勤務希望日数
        overtime: '',
        // 残業
        start_dt: '' // 希望スタート日時
      }],
      user: [{
        address: '',
        address_2: '',
        address_3: '',
        admin_id: '',
        age: '',
        birthday: '',
        blood_type: '',
        blood_type_rh: '',
        entry_date: '',
        gender: '',
        has_child: '',
        has_mate: '',
        home_station: '',
        home_station_line: '',
        home_station_line_2: '',
        is_search: '',
        mobile_phone_number: '',
        mobile_phone_number_memo: '',
        phone_number: '',
        phone_number_memo: '',
        post_code: '',
        staff_code: '',
        staff_type: '',
        user_name: '',
        user_name_kana: ''
      }]
    };
  },
  computed: {},
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var user, workexp, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.$route.params.id) {
              (0, _auth.setStaffID)(this.$route.params.id);
            }
            _context.next = 1;
            return _apolloClient.apolloClient.query({
              query: _userQuery.USER_QUERY,
              variables: {
                id: (0, _auth.getStaffID)()
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 1:
            user = _context.sent;
            this.$data.user = user.data.user;
            if (user.data.user.length > 0) {
              if (user.data.user[0].display_information !== '' && user.data.user[0].display_information !== null && user.data.user[0].display_information !== undefined) {
                this.display_information = JSON.parse(user.data.user[0].display_information);
              } else {
                this.display_information = {
                  disp_name: true,
                  disp_birthday: true,
                  disp_sex: true,
                  disp_age: true,
                  disp_address: true,
                  disp_final_education: true,
                  disp_work_history: true,
                  disp_qualification: true,
                  disp_transportation_facilities: true,
                  disp_desired_work_day: true,
                  disp_overtime: true,
                  disp_preferred_date: true,
                  disp_pr_comment: true
                };
              }
            } else {
              this.display_information = {
                disp_name: true,
                disp_birthday: true,
                disp_sex: true,
                disp_age: true,
                disp_address: true,
                disp_final_education: true,
                disp_work_history: true,
                disp_qualification: true,
                disp_transportation_facilities: true,
                disp_desired_work_day: true,
                disp_overtime: true,
                disp_preferred_date: true,
                disp_pr_comment: true
              };
            }
            _context.next = 2;
            return _apolloClient.apolloClient.query({
              query: _work_experienceQuery.GET_WORK_EXPERIENCE,
              variables: {
                staff_code: this.$data.user[0].id
              },
              fetchPolicy: 'no-cache'
            }).catch(function (error) {
              console.error('error' + error);
            });
          case 2:
            workexp = _context.sent;
            if (workexp.data.work_experience.length > 0) {
              if (workexp.data.work_experience[0].work_exp_year1 === '') {
                workexp.data.work_experience[0].work_exp_year1 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year2 === '') {
                workexp.data.work_experience[0].work_exp_year2 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year3 === '') {
                workexp.data.work_experience[0].work_exp_year3 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year4 === '') {
                workexp.data.work_experience[0].work_exp_year4 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year5 === '') {
                workexp.data.work_experience[0].work_exp_year5 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year6 === '') {
                workexp.data.work_experience[0].work_exp_year6 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year7 === '') {
                workexp.data.work_experience[0].work_exp_year7 = '　';
              }
              if (workexp.data.work_experience[0].work_exp_year8 === '') {
                workexp.data.work_experience[0].work_exp_year8 = '　';
              }
              if (workexp.data.work_experience[0].final_education_year === '') {
                workexp.data.work_experience[0].final_education_year = '　';
              }
              this.$data.form = workexp.data.work_experience;
              this.$data.form[0].work_exp_list = [{
                year: workexp.data.work_experience[0].work_exp_year1,
                month: workexp.data.work_experience[0].work_exp_month1,
                exp: workexp.data.work_experience[0].work_exp1
              }, {
                year: workexp.data.work_experience[0].work_exp_year2,
                month: workexp.data.work_experience[0].work_exp_month2,
                exp: workexp.data.work_experience[0].work_exp2
              }, {
                year: workexp.data.work_experience[0].work_exp_year3,
                month: workexp.data.work_experience[0].work_exp_month3,
                exp: workexp.data.work_experience[0].work_exp3
              }, {
                year: workexp.data.work_experience[0].work_exp_year4,
                month: workexp.data.work_experience[0].work_exp_month4,
                exp: workexp.data.work_experience[0].work_exp4
              }, {
                year: workexp.data.work_experience[0].work_exp_year5,
                month: workexp.data.work_experience[0].work_exp_month5,
                exp: workexp.data.work_experience[0].work_exp5
              }, {
                year: workexp.data.work_experience[0].work_exp_year6,
                month: workexp.data.work_experience[0].work_exp_month6,
                exp: workexp.data.work_experience[0].work_exp6
              }, {
                year: workexp.data.work_experience[0].work_exp_year7,
                month: workexp.data.work_experience[0].work_exp_month7,
                exp: workexp.data.work_experience[0].work_exp7
              }, {
                year: workexp.data.work_experience[0].work_exp_year8,
                month: workexp.data.work_experience[0].work_exp_month8,
                exp: workexp.data.work_experience[0].work_exp8
              }];
              if (this.$data.form[0].sex === 1) {
                this.$data.form[0].sex = '男';
              } else if (this.$data.form[0].sex === 2) {
                this.$data.form[0].sex = '女';
              } else {
                this.$data.form[0].sex = '';
              }
            }
            _context.next = 3;
            return (0, _appUtil.checkReadingFlag)(true);
          case 3:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 4;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    goToBack: function goToBack() {
      return this.$router.push({
        name: 'RecruitmentDetail',
        params: {
          id: (0, _auth.getRecruitmentID)()
        }
      });
    },
    displayStaffType: function displayStaffType(type) {
      if (type === null) return '';
      return _importCsvUserUtil.isSearchEnum.Label[_importCsvUserUtil.isBoolean.Label[type]];
    },
    displayBloodType: function displayBloodType(btype, bRh) {
      var type = '';
      var rh = '';
      if (btype) {
        type = _importCsvUserUtil.bloodType.Label[btype];
      }
      if (bRh) {
        rh = "(".concat(_importCsvUserUtil.bloodTypeRh.Label[bRh], ")");
      }
      return "".concat(type, " ").concat(rh);
    },
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    }
  }
};